export default {
  question: 'O que você precisa no segmento de [type] ?',
  description: 'Encontre aqui a melhor opção para você.',
};
